export const SubtaskApiRoutes = {
    GetCorrespondences: "api/v1/Subtask/GetCorrespondenceForEntity",
    GetSubtaskId: "api/v1/Subtask/GetSubtaskId",
    ReplyCorrespondence: "api/v1/Subtask/Reply",
    GetCorrespondence: "api/v1/Subtask/GetCorrespondence",
    AddSubtask: "api/v1/Subtask/AddSubtask",
    UpdateCorrespondenceReadIndicator: "api/v1/Subtask/UpdateCorrespondenceReadIndicator",
    AddAttachmentToEntityDocuments: "api/v1/Subtask/AddAttachmentToEntityDocuments",
    MarkAllAsRead: "api/v1/Subtask/MarkAllAsRead",
    SetAsAwaitingReponse: "api/v1/Subtask/SetAsAwaitingReponse",
    SetAsClosed: "api/v1/Subtask/SetAsClosed"
}